'use client';

import { useState } from 'react';
import HolidaySearchForm from './HolidaySearchForm';
import HolidayFilters from './HolidayFilters';
import HolidayResults from './HolidayResults';

export interface HolidaySearchParams {
  destination: string;
  duration: string;
  budget: string;
  travelers: number;
}

const HolidaySearchInteractive = () => {
  const [searchParams, setSearchParams] = useState<HolidaySearchParams>({
    destination: 'Maldives',
    duration: '7',
    budget: 'medium',
    travelers: 2,
  });
  const [hasSearched, setHasSearched] = useState(true);

  const handleSearch = (params: HolidaySearchParams) => {
    setSearchParams(params);
    setHasSearched(true);
  };

  return (
    <section className="py-8 lg:py-12">
      <div className="container mx-auto px-4">
        {/* Search Form */}
        <div className="mb-8">
          <HolidaySearchForm onSearch={handleSearch} initialParams={searchParams} />
        </div>

        {hasSearched && (
          <div className="flex flex-col lg:flex-row gap-6">
            {/* Filters Sidebar */}
            <aside className="lg:w-64 flex-shrink-0">
              <HolidayFilters />
            </aside>
            
            {/* Results */}
            <div className="flex-1">
              <HolidayResults searchParams={searchParams} />
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default HolidaySearchInteractive;